/*
 * File: index.js
 * Project: timo
 * File Created: Monday, 21st September 2020 8:46:33 pm
 * Author: Timo Zacherl
 * License: MPL-2.0
 *
 * -----
 * Last Modified: Thursday, 24th September 2020 5:42:25 pm
 * Modified By: Timo Zacherl
 * -----
 *
 * Copyright © 2020 Timo Zacherl. All rights reserved.
 */

import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/gitimoji",
    name: "Gitimoji",
    component: () =>
      import(/* webpackChunkName: "gitimoji" */ "../views/Gitimoji")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/legal",
    name: "Legal",
    component: () => import(/* webpackChunkName: "legal" */ "../views/Legal")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
